import { signOut } from '@aws-amplify/auth';

const handleSignOut = async (e) => {
  if (e) e.preventDefault();

  await signOut();

  window.location.replace('/');
};

export default handleSignOut;
